/**
 * @generated SignedSource<<d12a8f127812287c809d9c82007fe052>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksPostiesArticleArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"articleUtilsArticle" | "genericPostiesArticleContent">;
  readonly " $fragmentType": "hooksPostiesArticleArticle";
};
export type hooksPostiesArticleArticle$key = {
  readonly " $data"?: hooksPostiesArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksPostiesArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "customContents"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksPostiesArticleArticle",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "articleUtilsArticle",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleTypeSegment",
          "kind": "LinkedField",
          "name": "types",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ArticleType",
              "kind": "LinkedField",
              "name": "value",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entityId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "customContents",
          "variableName": "customContents"
        }
      ],
      "kind": "FragmentSpread",
      "name": "genericPostiesArticleContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "6b67e909c0fc599794cc5f9401d3d306";

export default node;
